import moment from 'moment';
import { PERSONNALISE } from '@/configuration/devisConf';
import checkLignesRegroupementPersoWithSameEcheancier
  from '@/services/commande/echeancierFacturation/checkLignesRegroupementPersoWithSameEcheancier';

function getLibelle(objectLibelleEcheancier, ligne) {
  const objectLibelleFind = objectLibelleEcheancier.find((objectLibelle) => {
    return (objectLibelle.idPatri === ligne.idPatri && objectLibelle.idPatri
      && moment(objectLibelle.dateDebut).isSame(moment(ligne.dateDebut)))
      || (ligne.referencePersonnalise === objectLibelle.referencePersonnalise
        && objectLibelle.referencePersonnalise);
  });
  if (objectLibelleFind && objectLibelleFind.referencePersonnalise === null) {
    objectLibelleFind.libelleProduit += ', ' + ligne.libelleProduit;
  } else if (!objectLibelleFind) {
    if (ligne.referencePersonnalise) {
      objectLibelleEcheancier.push({
        idPatri: null,
        libellePatri: null,
        dateDebut: null,
        libelleProduit: ligne.libelleReferencePersonnalise,
        referencePersonnalise: ligne.referencePersonnalise,
        libelleReferencePersonnalise: null,
      });
    } else {
      objectLibelleEcheancier.push(ligne);
    }
  }
}

function getLibelleReferencePerso(lignes, referencePersonnalise) {
  return lignes.find((ligne) => {
    return ligne.referencePersonnalise === referencePersonnalise && ligne.type === PERSONNALISE;
  }).libelle;
}

function getLignesCommandesWithReferenceEcheancier(lignes, referenceEcheancier) {
  const lignesFind = [];
  lignes.forEach((ligne) => {
    if (ligne.referenceEcheancier === referenceEcheancier) {
      lignesFind.push({
        idPatri: null,
        libellePatri: null,
        dateDebut: null,
        libelleProduit: ligne.libelle,
        referencePersonnalise: ligne.referencePersonnalise
        && checkLignesRegroupementPersoWithSameEcheancier(lignes, ligne.referencePersonnalise)
          ? ligne.referencePersonnalise : null,
        libelleReferencePersonnalise: ligne.referencePersonnalise
        && checkLignesRegroupementPersoWithSameEcheancier(lignes, ligne.referencePersonnalise)
          ? getLibelleReferencePerso(lignes, ligne.referencePersonnalise) : null,
      });
    }
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        if (ligneEnfant.referenceEcheancier === referenceEcheancier) {
          lignesFind.push({
            idPatri: ligne.produitId,
            libellePatri: ligne.libelle,
            dateDebut: ligne.dateDebut,
            libelleProduit: ligneEnfant.libelle,
            referencePersonnalise: ligneEnfant.referencePersonnalise
            && checkLignesRegroupementPersoWithSameEcheancier(
              lignes, ligneEnfant.referencePersonnalise,
            ) ? ligneEnfant.referencePersonnalise : null,
            libelleReferencePersonnalise: ligneEnfant.referencePersonnalise
            && checkLignesRegroupementPersoWithSameEcheancier(
              lignes, ligneEnfant.referencePersonnalise,
            ) ? getLibelleReferencePerso(lignes, ligneEnfant.referencePersonnalise) : null,
          });
        }
      });
    }
  });
  return lignesFind;
}

export default function getLibellesEcheancier(referenceEcheancier, lignes) {
  const lignesWithReferenceEcheancier = getLignesCommandesWithReferenceEcheancier(
    lignes, referenceEcheancier,
  );
  const objectLibellesEcheancier = [];
  lignesWithReferenceEcheancier.forEach((ligne) => {
    getLibelle(objectLibellesEcheancier, ligne);
  });
  return objectLibellesEcheancier;
}
